import { getOptionsStatus } from './dataStatus'

export default () => ({
  optionsStatus: [{id: null, label: 'Todos'}, ...getOptionsStatus()],
  entities: 'schedules',
  includes: ['agenda.professional', 'patient.degree', 'transfer', 'speciality'],
  schedules: [],
  currentSchedule: {},
  schedulesSelected: [],
  search: {
    agenda_id: null,
    convent_id: null,
    patient_type: null,
    patient_id: null,
    rule_id: null,
    speciality_id: null,
    transfer_id: null,
    date_start: null,
    date_end: null,
    price: null,
    status: 'scheduled',
    time: null
  },
  all: false,
  searchActive: false,
  scheduleIds: [],
  showModalRollback: false,
  showModalCancel: false,
  showModalAbsent: false,
  showModalTransfer: false,
  showModalReverser: false,
  showModalConfirmed: false,
  showBeforeDateError: false,
  showBeforeDate: false,
  typeAction: null,
  nextAction: false,
  showModalDelayed: false,
  showModalFromDelayedRollback: false,
  showModalInAttendance: false,
  showModalPresent: false,
  showIsTransferred: false,
  showIsDelayed: false,
  showIsScheduled: false,
  showIsAttended: false,
  showIsAbsent: false,
  showIsCanceled: false,
  showIsAttendance: false,
  showIsPresente: false,
  showIsRollback: false,
  showIsReverser: false,
  showIsPresent: false,
  optionActions: [
    {id: 'attended', label: 'Atendido'},
    {id: 'absent', label: 'Ausente'},
    {id: 'canceled', label: 'Cancelado'}
  ],
  optionLoadActions: [
    {value: 'scheduled', text: 'Agendado'},
    {value: 'delayed', text: 'Atrasado'},
    {value: 'attended', text: 'Atendido'},
    {value: 'absent', text: 'Ausente'},
    {value: 'canceled', text: 'Cancelado'},
    {value: 'in_attendance', text: 'Em Atendimento'},
    {value: 'present', text: 'Presente'}

  ]
})



// WEBPACK FOOTER //
// ./src/app/professional/schedulings/index/resources/data.js